import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Form, Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../../components/DataNotFound';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import AdminBanner from '../../../../../components/elements/AdminBanner';
import SearchFilters from '../../../../../components/elements/SearchFilter';
import { deleteAsync, getAsync, postAsync, putAsync } from '../../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../../components/helper/downloadCSVHelper';
import SuccessStoryModal from '../SuccessStoryModal';
import ImageViewModal from '../../../../../components/elements/ImageViewModal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DatePickerLayout from '../../../../../components/elements/DatePicker';
import { PageHitCountApi } from '../../../../../shared/Helper';
import { useLocation } from 'react-use';
const defaultImgSrc = '/img/defaultImg.jpg';
//import LoadingAnimation from '../../../../../components/LoadingAnimation';
import { printTable } from '../../../../../utils/tableExportUtils';
export default function ReadSuccessStory() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [values, setValues] = useState({
    title: '',
    publicationDate: '',
    filmingLocation: '',
    keywords: '',
    link: null,
    userID: 0,
    imageSrc: defaultImgSrc,
  });
  const [apiData, setApiData] = useState([]);
  const [title, setTitle] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [renderLink, setRenderLink] = useState('');
  // const [contentEn, setContentEn] = useState('');
  // const [contentAr, setContentAr] = useState('');
  const [doc, setDoc] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [filmingLocation, setFilmingLocation] = useState([]);
  const [locationStory, setLocationStory] = useState('');
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [keywords, setKeywords] = useState('');
  const [link, setLink] = useState('');
  const [file, setFile] = useState(null);
  const [base64URL, setBase64URL] = useState('');
  const [userID, setUserId] = useState('');
  const [gridModalcreate, setGridModalcreate] = useState(false);
  const [gridModalupdate, setGridModalupdate] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [recordID, setRecordID] = useState(null);
  const [searchTitle, setSearchTitle] = useState('');
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');

  const toggleShowCreate = (e) => {
    setGridModalcreate(!gridModalcreate);
    setTitleEn('');
    setTitle('');
    // setContentAr('');
    // setContentEn('');
    setPublicationDate('');
    setLocationStory('');
    setKeywords('');
    setBase64URL('');
    setFile('');
    fileInputRef.current.value = '';
  };
  const toggleShowUpdate = () => setGridModalupdate(!gridModalupdate);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const todayDate = new Date();
  const { pathname } = useLocation();

  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const bodyGet = {
    epUserID: epUser,
  };

  const getData = async () => {
    setIsLoad(true);
    await postAsync(
      `CMSSuccessStory/GetCMSSuccessStoryModelFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
      bodyGet,
      'multipart/form-data',
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        setNext(pageOptions.pageNo);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const body = {
    title,
    // contentEn,
    titleEn,
    // contentAr,
    publicationDate,
    locationStory,
    keywords,
    doc,
    file,
    userID,
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        //console.log('Called', reader);
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const showPreview = (e) => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        setValues({
          ...values,
          imageFile,
          imageSrc: x.target.result,
        });
        const base64 = x.target.result.split(',').splice(1, 1)[0];
        setDoc(base64);
      };
      reader.readAsDataURL(imageFile);
    } else {
      setValues({
        ...values,
        imageFile: null,
        imageSrc: defaultImgSrc,
      });
    }
  };

  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    const imgSize = selectedFile.size;
    const extension = selectedFile?.name.split('.')[1];
    if ((extension == 'jpg' || extension == 'png' || extension == 'PNG' || extension == 'jpeg') && imgSize <= 2097152) {
      getBase64(selectedFile)
        .then((result) => {
          selectedFile['base64'] = result;
          setBase64URL(result);
          setDoc(result.split(',')[1]);
          setFile(selectedFile);
          toast.success(t('File uploaded successfully.'));
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
        setBase64URL('');
        setFile('');
      }
      toast.error(t('Only PNG, JPG, and JPEG files are allowed. Maximum file size: 2MB.'));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (
        title == '' ||
        // contentEn == '' ||
        publicationDate == '' ||
        titleEn == '' ||
        // contentEn == '' ||
        // contentAr == '' ||
        // locationStory == '' ||
        keywords == '' ||
        base64URL == '' ||
        file == ''
      ) {
        toast.error(t(`please fill all fields`));
      } else {
        let data = {
          title,
          // contentEn,
          publicationDate,
          titleEn,
          // contentAr,
          locationStory: isActive ? filmingLocation?.ar_SA : filmingLocation?.en_US,
          keywords,
          base64URL,
          userID: epUser,
          file,
          successStoryID: 0,
        };

        await postAsync(
          'CMSSuccessStory/CreateCMSSuccessStory',
          data,
          {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
          'multipart/form-data',
        ).then((response) => {
          if (response?.statusCode === 200) {
            toast.success(`${t('Created Successfully')}`);
            setTitleEn('');
            setTitle('');
            // setContentAr('');
            // setContentEn('');
            setPublicationDate('');
            setLocationStory('');
            setKeywords('');
            setBase64URL('');
            setFile('');
            setDatanotfound(false);
            toggleShowCreate(e);
            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }
            getData();
          }
        });
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const getDataByID = async (Id) => {
    try {
      const response = await getAsync(`CMSSuccessStory/GetByIdCMSSuccessStory`, {
        id: Id,
      });

      if (response?.data && response?.data.length > 0) {
        const data = response?.data[0];
        setTitle(data?.title);
        setTitleEn(data?.titleEn);
        const date = data?.publicationDate.split('/');
        const formateddate = `${date[2]}-${date[1]}-${date[0]}`;
        setPublicationDate(formateddate);
        setKeywords(data?.keywords);
        // setContentAr(data?.contentAr);
        // setContentEn(data?.contentEn);
        setLocationStory(data?.locationStory);
        setLink(data?.link);
        setDoc(data?.doc);
        setUserId(data?.userID);
      } else {
        toast.error(t('Record Not Found.'));
      }
    } catch (err) {
      console.error(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const updateRecordById = (e, id) => {
    e.preventDefault();
    toggleShowUpdate();
    getDataByID(id);
    setRecordID(id);
  };

  const onUpdate = async (id) => {
    //e.preventDefault();
    if (
      title == '' ||
      // contentEn == '' ||
      publicationDate == '' ||
      titleEn == '' ||
      // contentEn == '' ||
      // contentAr == '' ||
      // locationStory == '' ||
      keywords == ''
    ) {
      toast.error(t(`please fill all fields`));
    } else {
      await putAsync(
        'CMSSuccessStory/UpdateCMSSuccessStory',
        body,
        {
          id: id,
        },
        'multipart/form-data',
      )
        .then((response) => {
          if (response?.statusCode === 200) {
            toast.success(`${t('Updated Successfully')}`);
            getData();
            setGridModalupdate(false);
            navigate('/readSuccessStory');
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
    (async function () {
      try {
        const response = await getAsync('Utilities/GetCountryList');
        setFilmingLocation(response?.data[0]);
      } catch (error) {
        toast.error(t('Something went wrong, Please try again!'));
      }
    })();
  }, []);

  const SearchFilter = {
    // epUserID: epUser,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    cmsTitle: searchTitle,
  };
  const SearchRecord = async () => {
    try {
      setIsLoad(true);
      setDatanotfound(false);
      const response = await postAsync(
        `CMSSuccessStory/GetCMSSuccessStoryModelFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(pageOptions.pageNo);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const onDelete = async (Id) => {
    await deleteAsync('CMSSuccessStory/DeleteCMSSuccessStory/', {
      id: Id,
    })
      .then((response) => {
        if (response?.statusCode === 200) {
          toast.success(`${t('Deleted Successfully')}`);
          getData();
          setApiData(response?.data);
        } else {
          toast.error(t('Something went wrong, Please try again!'));
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const handleOnSelectCountry = (selectedCountry) => {
    const id = selectedCountry.target.value;
    setLocationStory(id);
  };
  const validate = () => {
    let result = true;
    if (title === '' || title === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_title')}`);
    }

    if (publicationDate === '' || publicationDate === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_publicationDate')}`);
    }
    if (locationStory === '' || locationStory === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_locationStory')}`);
    }
    if (keywords === '' || keywords === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_keywords')}`);
    }
    if (link === '' || link === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_link')}`);
    }
    if (userID === '' || userID === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_userID')}`);
    }
    return result;
  };

  const openModal = async (e, successStoryID) => {
    e.preventDefault();
    // const selectedLink = apiData?.find((data) => data?.successStoryID === successStoryID)?.doc;
    try {
      const response = await getAsync('CMSSuccessStory/GetByIdCMSSuccessStory', {
        id: successStoryID,
      });
      setRenderLink(response?.data[0]?.doc);
    } catch (error) {
      console.log(error);
    }

    setGridModalOpen(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setGridModalOpen(false);
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    //setPageCount(select)
    await postAsync(
      'CMSSuccessStory/GetCMSSuccessStoryModelFilterList/' + select + '/' + pageOptions.pageSize,
      SearchFilter,
    )
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      Title: isActive ? item.title : item.titleEn,
      // Content: isActive ? item.contentAr : item.contentEn,
      'Publication Date': item.publicationDate,
      'News Place': item?.locationStory ? item?.locationStory : 'N/A',
      Keywords: item.keywords,
    }));
    downloadCSV(filteredData, 'Read Success Story');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('SuccessStory List')}`; // Replace with your desired heading text
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('cms_title')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_publicationDate`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_newsPlace`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_keywords`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.title || '' : data?.titleEn || ''}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.publicationDate}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.locationStory ? data?.locationStory : 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.keywords || 'N/A'}</td>
  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
  const handlePrint = (e) => {
    e.preventDefault();

    // Column configuration
    const columns = [
      {
        header: t('sNo'),
        accessor: (row, index) => index + 1,
      },
      {
        header: t('cms_title'),
        accessor: (row) => (isActive ? row?.title : row?.titleEn),
      },
      {
        header: t('cms_publicationDate'),
        accessor: (row) => (isActive ? row?.publicationDate || 'N/A' : row?.publicationDate || 'N/A'),
      },
      {
        header: t('cms_newsPlace'),
        accessor: (row) => (isActive ? row?.locationStory || 'N/A' : row?.locationStory || 'N/A'),
      },
      {
        header: t('cms_keywords'),
        accessor: (row) => row?.keywords || 'N/A',
      },
    ];

    // Call the reusable print function
    printTable({
      data: apiData || [],
      isRTL: isActive, // isActive true = Arabic = RTL
      t: t,
      title: `${t('Success Story list')} `,
      columns: columns,
      onBeforePrint: () => {
        console.log('Printing started...');
        // toast.info(t('Preparing print preview...'));
      },
      onAfterPrint: () => {
        console.log('Printing completed');
      },
      styles: {
        customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `,
      },
    });
  };
  const handleDownload = async (e, id, fileName) => {
    e.preventDefault();
    try {
      const response = await getAsync('CMSPressRelease/GetByIdCMSPressRelease', { id: id });
      const link = document.createElement('a');
      link.href = `data:image/png;base64,${response?.data[0]?.doc}`; // Update MIME type based on your image format
      link.download = fileName || 'image.png'; // Set the desired file name or fallback to 'image.png'
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;

    return (
      // eslint-disable-next-line react/jsx-key
      <Table.Row className="text-sm" key={sno}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{isActive ? data?.title || '' : data?.titleEn || ''}</Table.Cell>
        {/* <Table.Cell>{isActive ? data?.contentAr || '' : data?.contentEn || ''}</Table.Cell> */}
        <Table.Cell>{data?.publicationDate}</Table.Cell>
        <Table.Cell>{data?.locationStory ? data?.locationStory : 'N/A'}</Table.Cell>
        <Table.Cell>{data?.keywords}</Table.Cell>
        <Table.Cell>
          {/* Modal View */}
          <>
            <button
              className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
              onClick={(e) => openModal(e, data?.successStoryID)}
              style={{
                margin: '5px',
              }}
            >
              {' '}
              <VisibilityOutlinedIcon />
            </button>

            <button
              className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
              onClick={(e) => handleDownload(e, data?.successStoryID, data?.fileName)}
              style={{ margin: '5px' }}
            >
              <FileDownloadOutlinedIcon />
            </button>
          </>
          {/* end */}
        </Table.Cell>

        <Table.Cell>
          <button
            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
            type="button"
            onClick={(e) => {
              updateRecordById(e, data?.successStoryID);
            }}
          >
            {t('Update')}
          </button>
        </Table.Cell>
        <Table.Cell>
          <button
            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center
"
            onClick={() => onDelete(data.successStoryID)}
          >
            {t('delete')}
          </button>
        </Table.Cell>
      </Table.Row>
    );
  });
  return (
    <div className="">
      {!isLogin ? (
        <h1>{t('Not Authorized')}</h1>
      ) : (
        <>
          <div className="container-fluid ">
            <div className="row text-center">
              <div className="col-lg-11 flex justify-end my-4">
                <button
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                  onClick={toggleShowCreate}
                >
                  {t('create')}
                </button>
              </div>
            </div>

            <div className="row justify-center flex-row">
              <SearchFilters
                handleSearch={SearchRecord}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'Success Story list'}
                isTitleVisible={true}
                setSearchTitle={setSearchTitle}
                isApplicantName={false}
              />
            </div>

            {/* Modal Create */}
            <>
              <MDBModal tabIndex="-1" show={gridModalcreate} setShow={setGridModalcreate}>
                <MDBModalDialog className="flex justify-center items-center">
                  <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                    <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                      <MDBModalHeader>
                        <MDBModalTitle className="text-customgreen font-semibold">
                          {t('create')} {t('cms_successStory')}
                        </MDBModalTitle>
                        {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div className="container-fluid bd-example-row">
                          <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('cms_title')} : </label>
                                <input
                                  type="text"
                                  maxLength={1000}
                                  name="title"
                                  value={title}
                                  className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  onChange={(e) => setTitle(e.target.value)}
                                  placeholder={t('cms_title')}
                                />
                              </Form.Field>
                            </div>

                            <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('Title En')} : </label>
                                <input
                                  type="text"
                                  maxLength={1000}
                                  name="title"
                                  value={titleEn}
                                  className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  onChange={(e) => setTitleEn(e.target.value)}
                                  placeholder={t('Title En ')}
                                />
                              </Form.Field>
                            </div>
                            {/* <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('cms_content')}</label>
                                <textarea
                                  name="content"
                                  value={contentAr}
                                  onChange={(e) => setContentAr(e.target.value)}
                                  className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  placeholder={t('cms_content')}
                                />
                              </Form.Field>
                            </div> */}
                            {/* <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('Content En')} : </label>
                                <textarea
                                  name="title"
                                  value={contentEn}
                                  className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  onChange={(e) => setContentEn(e.target.value)}
                                  placeholder={t('Content En')}
                                />
                              </Form.Field>
                            </div> */}
                          </div>
                          <div className="row" style={{ marginBottom: '5px' }}>
                            <div className="col-md-6 ms-auto col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('Story Location')} : </label>
                                <input
                                  type="text"
                                  disabled
                                  name="filmLocation"
                                  value={isActive ? filmingLocation?.ar_SA : filmingLocation?.en_US}
                                  className=" border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  cursor-not-allowed"
                                  // onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                                  placeholder={t('cms_newsPlace')}
                                />
                                {/* <select
                                  name="storylocaton"
                                  value={locationStory}
                                  required
                                  className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                                  placeholder={t('Story locaton')}
                                >
                                  <option value={0}>--{t('Select Country')}--</option>
                                  {filmingLocation && filmingLocation.length > 0 ? (
                                    filmingLocation?.map((item) => {
                                      return (
                                        <option key={item.countryID} value={item?.countryName}>
                                          {isActive ? item?.ar_SA : item?.countryName}
                                        </option>
                                      );
                                    })
                                  ) : (
                                    <option>{t('Select country')}</option>
                                  )}
                                </select> */}
                              </Form.Field>
                            </div>
                            <div className="col-md-6 col-example">
                              <label className="mx-auto text-customgreen">{t('cms_keywords')} : </label>
                              <input
                                type="text"
                                name="keywords"
                                value={keywords}
                                onChange={(e) => setKeywords(e.target.value)}
                                className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                placeholder={t('cms_keywords')}
                              />
                            </div>
                          </div>
                          <div className="row" style={{ marginBottom: '5px' }}>
                            <div className="col-md-6 form-group flex flex-col ">
                              <DatePickerLayout
                                label={'cms_publicationDate'}
                                selectedDate={publicationDate}
                                keyValue={'to'}
                                dateTo={publicationDate}
                                setDateTo={setPublicationDate}
                                maxDate={todayDate}
                              />
                            </div>
                            <div className="col-md-6 ms-auto col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('cms_image')}</label>
                                <input
                                  ref={fileInputRef}
                                  accept=".png, .jpg, .jpeg"
                                  onChange={handleFileInputChange}
                                  type="file"
                                  className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                />
                              </Form.Field>
                            </div>
                          </div>
                          <div className="flex justify-center mt-2 ">
                            <hr className="my-3" />
                            <img
                              style={{
                                height: '120px',
                                width: '150px',
                              }}
                              src={base64URL ? `${base64URL}` : values.imageSrc}
                              //onChange={(e) => setLink(e.target.files[0])}
                              className="card-img-top"
                              alt=""
                            />
                          </div>
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter className="flex justify-center">
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
                          onClick={(e) => {
                            handleSubmit(e);
                          }}
                        >
                          {t('create')}
                        </button>
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={toggleShowCreate}
                        >
                          {t('close')}
                        </button>
                      </MDBModalFooter>
                    </Form>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </>

            {/* Modal Update */}

            <SuccessStoryModal
              updateRecordById={updateRecordById}
              t={t}
              gridModalupdate={gridModalupdate}
              setGridModalupdate={setGridModalupdate}
              recordID={recordID}
              title={title}
              setTitle={setTitle}
              titleEn={titleEn}
              setTitleEn={setTitleEn}
              // contentAr={contentAr}
              // setContentAr={setContentAr}
              // contentEn={contentEn}
              // setContentEn={setContentEn}
              publicationDate={publicationDate}
              setPublicationDate={setPublicationDate}
              locationStory={locationStory}
              handleOnSelectCountry={handleOnSelectCountry}
              filmingLocation={filmingLocation}
              keywords={keywords}
              setKeywords={setKeywords}
              doc={doc}
              setDoc={setDoc}
              showPreview={showPreview}
              //applyErrorClass={applyErrorClass}
              link={link}
              values={values}
              setLink={setLink}
              onUpdate={onUpdate}
              onChange={handleFileInputChange}
              fileInputRef={fileInputRef}
            />
            {/* end */}
            {/*  Image View Modal */}

            <ImageViewModal
              showModal={gridModalOpen}
              setShowModal={setGridModalOpen}
              closeModal={closeModal}
              title={''}
              renderLink={''}
              imgDoc={renderLink}
            />
            {/*  Image View Modal End */}
            <div className="flex flex-col pt-9">
              <div className="row pb-5  justify-center">
                {isLoad ? (
                  <LoadingAnimation />
                ) : (
                  <div className="col-lg-11 text-center">
                    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                      <Table className="text-sm tableData text-center  rtl:text-right ">
                        <Table.Header className="font-bold  text-white whitespace-nowrap bg-customgreen uppercase ">
                          <Table.Row>
                            <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_title')}</Table.HeaderCell>
                            {/* <Table.HeaderCell className="text-white">{t('cms_content')}</Table.HeaderCell> */}
                            <Table.HeaderCell className="text-white">{t('cms_publicationDate')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_newsPlace')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_keywords')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                            <Table.HeaderCell>{t('')}</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>{displayRecords}</Table.Body>
                      </Table>
                      {datanotfound && <DataNotFound />}
                    </div>

                    {pageCount > 0 && (
                      <div className="flex flex-row px-12 justify-between">
                        <Menu pagination>
                          <Menu.Item>
                            <ReactPaginate
                              previousLabel={t('Previous')}
                              nextLabel={t('Next')}
                              pageCount={pageCount}
                              onPageChange={changePage}
                              containerClassName={'paginationButtons'}
                              previousLinkClassName={'previousButton'}
                              nextLinkClassName={'nextButton'}
                              disabledClassName={'paginationDisabled'}
                              activeClassName={'paginationActive'}
                            />
                          </Menu.Item>
                        </Menu>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
